import { paymentActionTypes } from '../actions/types';
import _ from 'lodash';

const initialState = {
    payments: []
};

export function payment(state = initialState, action) {
    switch (action.type) {
        case paymentActionTypes.RESET_STATE:
            return {
                ...initialState,
            };
        case paymentActionTypes.REPORT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case paymentActionTypes.REPORT_SUCCESS:
            return {
                ...state,
                payments: action.payments,
                loading: false,
            };
        case paymentActionTypes.REPORT_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        default:
            return state;
    }
}